module.exports = __webpack_public_path__ + "img/banco-inter.d74c8010.svg";